<div class="container" [ngClass.xs] = "'extra-small-scr-container'">
    <div class="header-container">
        <div class="header-column-one" fxFlex.xs = "22%">
            <h3 class="title" [ngClass.xs] = "'extra-small-scr-title'">Due Date</h3>
        </div>
        <div class = "header-column-two" fxFlex.xs = "30%">
            <h3 class="title" [ngClass.xs] = "'extra-small-scr-title'">Title and Description</h3>
        </div>
        <div class = "header-column-three" fxFlex.xs = "20%">
            <h3 class="title" [ngClass.xs] = "'extra-small-scr-title'">Meeting Discussed</h3>
        </div>
        <div class= "header-column-four">
            <h3 class="title" [ngClass.xs] = "'extra-small-scr-title'">Progress</h3>
        </div>
    </div>
    <div class="content-container" [ngStyle.xs] = "'extra-small-scr-content-container'">
        <mat-card appearance="outlined" (click) = "openTaskListItemDialog()" [ngClass.xs]="'extra-small-scr-mat-card'">
            <mat-list>
                <mat-list-item>
                    <div class="list-column-one" fxFlex.xs = "18%">
                        <div>
                            <h3 [ngStyle.xs] = "{
                                'font-size.px' : 10,
                                'margin-left.px' : -12
                             }">{{currentDate}}</h3>
                        </div>
                    </div>
                    <div class="list-column-two" fxFlex.xs = "38%">
                        <div>
                            <h3 [ngStyle.xs] = "{
                                'font-size.px' : 10,
                                'padding-left.px' : 5
                             }">Agora UI Discussion</h3>
                        </div>
                        <div>
                            <h3 [ngStyle.xs] = "{
                                'font-size.px' : 10,
                                'padding-left.px' : 5
                             }">Assigned by: M Lakshmikala</h3>
                        </div>
                    </div>
                    <div class="list-column-three" fxFlex.xs = "20%">
                        <h3 [ngStyle.xs] = "{
                            'font-size.px' : 10,
                            'margin-left.px' : -12
                         }">Meeting Title</h3>
                    </div>
                    <div class="list-column-four" fxFlex.xs = "20%" fxLayout.xs = "column" fxLayoutAlign.xs = "start start">
                        <div>
                            <input type="checkbox"/>
                        </div>
                        <div>
                            <button class="ongoing" mat-raised-button [ngStyle.xs] = "{
                                'font-size.px' : 10
                             }">Ongoing</button>
                        </div>
                    </div>  
                </mat-list-item>
            </mat-list>
        </mat-card>
        <div>
            <app-pagination></app-pagination>
        </div>
    </div>
</div>